import * as sessionApi from '@/api/sessionApi';
import cda from './cda';
import pdf from './pdf';
import report from './report';
import watch from './watch';
import provider from './provider';
import preferences from './preferences';

import { setCsrf, setApplicationModel, LoggedOut,LoggedIn } from '@/mutation-types';
import { RESET_TIMER } from '@/constants/event';

import {ResumeFsm,NoResumeFsm,LoginFailure,LoginNavigation} from './fsm/messages';
import * as messages from './fsm/messages';
import Vue from 'vue';
import { post } from '@/store/modules/fsm/index';
import router from '@/router/index';
import _ from 'lodash';

import {
  FEATURES
} from '@/config';

let { LoggedIn:LoggedInMessage } = messages;

const state = {
  phrData: null,
  loggedIn: false,
  sessionId: null,  //TODO: sessionId is not used at the moment
  csrf: {
    param: null,
    token: null
  }
};

const getters = {
  getCsrf: state => state.csrf,
  getAllData: state => state.phrData,
  isLoggedIn: state => state.loggedIn,
  getSessionId: state => state.sessionId,
  getUser: state => {
    return {...state.phrData.user, ...state.phrData.patient};
  },
  getTaxonomies: state => {
    if(!FEATURES.cda_header_providers)
      return _.pickBy(state.phrData.taxonomies,taxo=>_.some(taxo.npis,npi=>{
        return state.phrData.npiGroupings[npi];
      }));
    else
      return {...state.phrData.taxonomies};
  },
  getProviders: state => {
    return {...state.phrData.npis};
  },
  getPatientRelations: state => {
    return {...state.phrData.patient.relations}
  },
};

const mutations = {
  [setCsrf] (state,csrf) {
    Vue.set(state,'csrf',csrf);
  },
  [setApplicationModel] (state,payload) {
    Vue.set(state,'phrData',payload);
  },
  [LoggedOut] (state) {
    Vue.set(state, 'phrData', null);
    state.loggedIn = false;
    state.sessionId = null;
  },
  [LoggedIn] (state, payload) {
    Vue.set(state, 'phrData', payload.data);
    state.loggedIn = true;
  },
  addMeasures (state, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
    Vue.set(state.phrData, 'measures', {...state.phrData.measures,...externalMeasures});
    Vue.set(state.phrData, 'ccds', {...state.phrData.ccds,...externalMeasCcds});
    
    let measCcdMeasIds = state.phrData.measCcdMeasIds || [];
    for (let measCcd in externalMeasCcdMeasIds) {
      if (measCcdMeasIds[measCcd]) {
        measCcdMeasIds[measCcd] = _.union(measCcdMeasIds[measCcd],externalMeasCcdMeasIds[measCcd]);
      } else {
        measCcdMeasIds[measCcd] = externalMeasCcdMeasIds[measCcd];
      }
    }
    Vue.set(state.phrData, 'measCcdMeasIds', measCcdMeasIds);
    
  }
};
const actions = {
  updateCsrf({commit},csrf) {
     commit(setCsrf,csrf);
  },
  inlineUpdateApplicationModel({commit},data) {
    commit(setApplicationModel, data);
  },
  updateApplicationModel({commit}) {
    return new Promise((resolve) => {
      sessionApi.getAllData()
      .then((applicationModel) => {
        commit(setApplicationModel, applicationModel);
        commit('watch/setExternalMeasuresLoaded',false);
        resolve();
      })
      .catch((err) => {
        console.error(err);
      });
    });
  },
  async showLoginPrompt({commit}) {
    commit(LoggedOut);
    router.push({name:LoginNavigation})
  },
  async getInitialMessage({commit}) {
    let _message = { message : NoResumeFsm };
    try {
      let { data,instance,message,watch:watchValue } = await sessionApi.getInitialMessage(); 
      if(message && message === 'resumeApplicationMessage'/** && state.loggedIn && state.phrData != null */ ) {
        commit('watch/setExternalMeasuresLoaded', false);
        _message = { message: ResumeFsm,data,instance,watch:watchValue };
      } 
    }
    catch(err) {
      alert(err);
    }
    return post(_message);
  },
  async login ({commit},{loader,patient,password,LoginPage}) {
    let _message = {message:LoginFailure};
    try {
      let response = await sessionApi.login({patient,password});

      commit('watch/setExternalMeasuresLoaded', false);
      Vue.vueEventBus.$emit(RESET_TIMER,{ping:true});
      _message = { ...response };
      _message.message = LoggedInMessage;
    }
    catch(err) {
      //TODO: 
      LoginPage.statusMessage = err;
      // LoginPage.statusMessage = 'Invalid login';
    }
    loader.hide();
    post(_message);
  },
  async logout({commit}) {
    try {
      await sessionApi.logout();
    }
    catch(err) {
      text = `error in trying to logout: ${err}`;
      this.$swal({
        type: 'error',
        title: 'Unable to log out',
        text
      });
      throw text;
    } finally {
      commit(LoggedOut);
      commit('cda/clearCda');
      commit('pdf/clearPdf');
      commit('report/clearReport');
      commit('watch/clearAllWatches');
      //TODO: reset fsm ?
      window.sessionStorage.clear();
    }
  },
  resetSession({commit, dispatch}) {
    commit(LoggedOut);
    // router.push({name:LoginNavigation});
    commit('cda/clearCda');
    commit('pdf/clearPdf');
    commit('report/clearReport');
    commit('watch/clearAllWatches');
    //TODO: reset fsm ?
    window.sessionStorage.clear();
  },
  addMeasures({commit}, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
    commit('addMeasures', {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds});
  } 
};

const modules = {
  cda,
  pdf,
  report,
  watch,
  provider,
  preferences
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
}
